/**
 * Plain-text prompt for an AI chatbot to implement one recommendation.
 */
export function implementationInstruction(action, site) {
  const where = site ? ` on ${site}` : "";
  const lines = [`Implement this change${where}.`, "", `Task: ${action.title}`];

  if (action.category) lines.push(`Kind: ${action.category}`);
  if (action.problem) lines.push("", "Problem:", action.problem);
  if (action.solution) lines.push("", "What to change:", action.solution);

  const why = action.business_value || action.businessValue;
  if (why) lines.push("", "Why it matters:", why);

  const notes = action.code_example || action.implementation;
  if (notes) lines.push("", "Implementation:", notes);

  lines.push(
    "",
    "Change the existing site. Do not add pages, claims, or files this task does not ask for. When you are done, say what you changed.",
  );

  return lines.join("\n");
}
